define('gigaset_recurring/classes/provider/billwerk/steps/shipping-method',[
	"jquery",
	"lodash",
	"./_abstract",
	"cartware/jquery/bem",
	"cartware/components/Registry",
	"cartware/components/Logger",
	"jquery-serialize-object"
], function(
	$,
	_,
	AbstractStep,
	BEM,
	Registry,
	Logger
) {

	function ShippingMethodStep() {
		AbstractStep.call(this);
		this.logger = Logger.getLogger("gigaset_recurring.shipping_method");
	}

	ShippingMethodStep.prototype = _.create(new AbstractStep, {
		constructor: ShippingMethodStep,

		initialize: function() {
			this.block = BEM.block("gigaset-recurring-checkout-shipping-methods");
			this.children = this.block.getElements("children");
			this.form = this.block.getElements("form");
			this.backButton = this.block.getElements("back-button");
			this.proceedButton = this.block.getElements("proceed-button");

			this.patchCompatibility();
			this.bindEvents();
		},

		patchCompatibility: function() {
			if (_.isUndefined(window.lastPrice)) {
				window.lastPrice = null;
			}

			if (_.isUndefined(window.quoteBaseGrandTotal)) {
				window.quoteBaseGrandTotal = null;
			}
		},

		bindEvents: function() {
			this.form.on("submit", _.bind(function(e) {
				e.preventDefault();
				this.submit();
			}, this));
			this.backButton.on("click", _.bind(this.previous, this));
			this.getData("module").on("updateBlocks", _.bind(this.updateBlocks, this));
		},

		updateBlocks: function(blocks) {
			if ("shipping-methods" in blocks) {
				this.children.html(blocks["shipping-methods"]);
			}
		},

		validate: function() {
			var valid = !_.isEmpty(_.get(this.collectFormData(), "shipping_method"));
			var module = this.getData("module");

			if (!valid) {
				module.handleError(new Error("No shipping method chosen"), module.translate("Please select a shipping method"));
			}

			return valid;
		},

		collectFormData: function() {
			var formData = this.form.serializeObject();

			return {
				shipping_method: _.get(formData, "shipping_method")
			}
		},

		/**
		 * Collect data from the step and save it via this.addData
		 * @returns {Promise}
		 */
		saveFormData: function() {
			this.proceedButton.button("loading");
			return this.saveFormDataServerSide().then(_.bind(function() {
				this.proceedButton.button("reset");
			}, this));
		}
	});

	return ShippingMethodStep;

});
